<script>
import CrudList from 'Arch/components/crud/CrudList.vue';
import TemplatesRequest from 'Modules/contacard/communication/templates/TemplatesRequest';
import TemplateStatusColumn from 'Modules/contacard/communication/templates/components/datatable/TemplatesStatusColumn.vue';
import TemplateCheckboxColumnVue from './components/datatable/TemplateCheckboxColumn.vue';
import TemplateViewColumnVue from './components/TemplateViewColumn.vue';

export default {
  name: 'TemplatesCrudList',
  extends: CrudList,
  data: () => ({
    components: { TemplateStatusColumn },
    requestClass: TemplatesRequest,
    editRoute: 'contacard.communication.templates.edit',
    hideDelete: true,
    hideEdit: true,
    headers: [
      {
        text: 'Template',
        value: 'name',
      },
      {
        text: 'Descrição',
        value: 'description',
        class: 'wrap',
        width: '20%',
        options: {
          shouldWrap: true,
        },
        tooltip: true,
      },
      {
        text: 'Comunicação externa',
        value: 'isExternalReceiver',
        component: TemplateCheckboxColumnVue,
      },
      {
        text: 'E-mail',
        value: 'email',
        component: TemplateStatusColumn,
      },
      {
        text: 'SMS',
        value: 'sms',
        component: TemplateStatusColumn,
      },
      {
        text: 'Notificação Push',
        value: 'push',
        component: TemplateStatusColumn,
      },
      {
        text: 'PDF',
        value: 'pdf',
        component: TemplateStatusColumn,
      },
      {
        text: 'Notificação',
        value: 'notification',
        component: TemplateStatusColumn,
      },
      {
        text: 'Última edição',
        value: 'updatedAt',
        component: 'DataTableDateColumn',
      },
      {
        text: 'Último editor',
        value: 'updatedBy',
      },
      {
        text: 'Ação',
        value: 'id',
        component: TemplateViewColumnVue,
      },
    ],
  }),
  methods: {
    prepareResponseData(data) {
      return data.map((item) => ({
        ...item,
        name: item.name.replace('Template', ''),
      }));
    },
  },
};
</script>
